export enum AppointmentStatusEnum {
  SCHEDULED = "SCHEDULED",
  ACTIVE = "ACTIVE",
  LOGGED = "LOGGED",
  ABSENT = "ABSENT",
  CANCELLED = "CANCELLED",
  CHECKED_IN = "CHECKED_IN",
  DELETED = "DELETED",
}

export enum AppointmentTypeEnum {
  PARTICIPANT_OWNER = "PARTICIPANT_OWNER",
  SUPERVISION = "SUPERVISION",
  IN_HOUSE_SERVICE = "IN-HOUSE_SERVICE",
  EXTERNAL_PROVIDER_SERVICE = "EXTERNAL_PROVIDER_SERVICE",
}

export enum AppointmentMeetingTypeEnum {
  INDIVIDUAL = "INDIVIDUAL",
  GROUP = "GROUP",
}

export interface TreatmentAgencyLocation {
  _id: string;
  code: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state?: string;
  postalCode: string;
  latitude: number;
  longitude: number;
  email: string;
  phone: string;
}

export interface TreatmentAgency {
  _id: string;
  name: string;
  location: TreatmentAgencyLocation;
  contact: string;
}

export interface Appointment {
  _id: string;
  title: string;
  subject: string;
  dateTimeRange: string;
  organizer: string;
  status: AppointmentStatusEnum;
  type: AppointmentTypeEnum;
  startDate: string;
  endDate: string;
  comment?: string;
  treatmentAgencyId?: string;
  locationId?: string;
  contactName?: string;
  appointmentReasonId?: string;
  treatmentAgency?: TreatmentAgency;
  uiStatus: string;
  checkInEnabled: boolean;
  showReschedule: boolean;
  showCancel: boolean;
  showMap: boolean;
  showCheckIn: boolean;
  showRewardsWarning: boolean;
}

export interface AppointmentsResponse {
  appointments: Appointment[];
  totalCount: number;
}

export interface GetAppointmentsParams {
  participantId: string;
  pageNumber?: number;
  pageSize?: number;
  sortField?: string;
  sortOrder?: "asc" | "desc";
  filter?: "all" | "last7" | "last14" | "last30" | "next30";
}

export type AppointmentFilter =
  | "all"
  | "last7"
  | "last14"
  | "last30"
  | "next30";

export interface AppointmentFilterOption {
  key: AppointmentFilter;
  value: string;
}
